import React from 'react';
import {RentalType} from "../../../../constant/CodeSpecNum";
import RentalAssetModal from "../../../../packages/lifecycle/rentalAsset/subPage/RentalAssetModal";
import {changeRentalAssetActive} from "../../../../api/lifecycle/rental/rentalAssetService";
import {handleActiveToast} from "../../../sonner/ToastBasic";
import {useTranslation} from "react-i18next";

const RentalAssetTableButtonGroup = ({keys, data, item, refresh}) => {
    return (
        <div className={'flex justify-center ml-2'}>
            {item.rentalType === RentalType.AVAILABLE.value &&
                <>
                    <RentalAssetModal
                        rentalAsset={{
                            id: item.id,
                            asset: {assetName: item.assetName},
                            code: {name: item.codeName}
                        }}
                        refresh={refresh}
                    />
                </>
            }
        </div>
    );
};

const RentalAssetTableActive = ({key, data, item, refresh}) => {
    const {t} = useTranslation();
    const handleChangeActive = async (e) => {
        e.stopPropagation();
        const payload = {id: item.id, active: !item.active};
        await changeRentalAssetActive(payload, () => {
            handleActiveToast({message: t(`updated`)});
            if (refresh) refresh();
        });
    }

    const isRentalAssetDesignated = () => {
        return item.rentalType === RentalType.RENT.value || item.rentalType === RentalType.OCCUPIED.value;
    }

    // 대여중·예약 상태에서는 대여가능 여부를 변경할 수 없어 상태 텍스트만 노출
    if (isRentalAssetDesignated()) {
        const designatedLabel = item.rentalType === RentalType.RENT.value
            ? RentalType.RENT.kor
            : RentalType.REQUEST.kor;
        return (
            <div className={'flex items-center justify-center h-full'}>
                <span className={'text-[13px] text-[#666]'}>{designatedLabel}</span>
            </div>
        );
    }

    const on = !!item.active;

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'}}>
            <span style={{fontSize: '13px', color: on ? '#333333' : '#bd1111'}}>
                {on ? '대여가능' : '대여불가'}
            </span>
            <RentalActiveSwitch on={on} onClick={handleChangeActive}/>
        </div>
    )
}

/** 대여가능 여부 토글 스위치 (초록 트랙 + 흰색 단추) */
const RentalActiveSwitch = ({on, onClick, title}) => (
    <button
        type={'button'}
        role={'switch'}
        aria-checked={!!on}
        onClick={onClick}
        title={title ?? (on ? '대여불가로 변경' : '대여가능으로 변경')}
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: on ? 'flex-end' : 'flex-start',
            flexShrink: 0,
            boxSizing: 'border-box',
            width: '38px',
            height: '20px',
            padding: '2px',
            border: 'none',
            borderRadius: '9999px',
            cursor: 'pointer',
            backgroundColor: on ? '#22c55e' : '#d1d5db',
            transition: 'background-color 0.2s ease',
        }}
    >
        <span
            style={{
                display: 'block',
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: '#ffffff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
            }}
        />
    </button>
);

export {RentalAssetTableButtonGroup, RentalAssetTableActive, RentalActiveSwitch};
